import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { BusinessesResponse } from '../types/index';

type UseBusinessOptions = {
  businessId?: number;
  search?: string;
  page: number;
  perPage: number;
  isPast?: boolean;
};
export const getBusinesses = (
  { businessId, search, page, perPage, isPast }: UseBusinessOptions = {
    page: 1,
    perPage: 10,
  }
): Promise<BusinessesResponse> => {
  return axios.get(`/public/business/all`, {
    params: { search, page, perPage },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getBusinesses>;
};

export const useBusinesses = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBusinesses,
  });
};
